var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.RequestsList,{attrs:{"title":_setup.config.title,"subtitle":_setup.config.subtitle,"filters":_setup.config.filters,"columns":_setup.config.columns,"showExportButton":_setup.config.showExportButton}})
}
var staticRenderFns = []

export { render, staticRenderFns }